module.exports = ".hubspot-container .hs-form-frame{color:#fff;padding:0}";